import React from 'react';
import Svg, { Path } from 'react-native-svg';
var SVGComponent = function SVGComponent(props) {
  var style = props.style;
  return /*#__PURE__*/React.createElement(Svg, {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    style: style
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M4.31071 11.2501L11.5304 4.03039L10.4697 2.96973L1.97497 11.4645C1.83614 11.6006 1.75 11.7903 1.75 12.0001C1.75 12.2101 1.83631 12.3999 1.97539 12.5361L10.4697 21.0304L11.5304 19.9697L4.31072 12.7501H22.5V11.2501H4.31071Z",
    fill: "black",
    fillOpacity: "0.65"
  }));
};
export default SVGComponent;